export const useParentSlugFilter = (slug) => {
  if (Array.isArray(slug) && slug.length > 1) {
    const slugs = slug.map((slug2) => slug2);
    slugs.pop();
    slugs.reverse();
    const findLast = (obj) => {
      if (obj.parent) {
        return findLast(obj["parent"]);
      }
      return obj;
    };
    const tmp = slugs.reduce(
      (f, s) => {
        const c2 = findLast(f);
        c2["parent"] = {
          slug: s
        };
        return f;
      },
      {}
    );
    const c = findLast(tmp);
    c["parent"] = {
      slug: {
        $null: true
      }
    };
    return tmp;
  }
  return {
    parent: {
      slug: {
        $null: true
      }
    }
  };
};
